<section class="p-4">
    <p>{{ 'EXPERIMENTAL_FEATURES.DESCRIPTION' | translate }}</p>

    <table class="table table-dark table-hover">
        <thead>
            <tr>
                <th>Feature</th>
                <th>Off/On</th>
                <th>Default setting</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let expFeature of experimentalFeaturesService.allExperimentalFeatures">
                <td>{{ expFeature.label }}</td>
                <td>
                    <ca-switch
                        (onChange)="experimentalFeaturesService.setExperimentalFeature(expFeature.identifier, $event)"
                        [checked]="experimentalFeaturesService.isFeatureActivated(expFeature.identifier)"
                        data-uit="experimental-feature-switch"
                        class="experimental-feature-switch {{ expFeature.identifier }}"
                        [size]="'small'"
                    ></ca-switch>
                </td>
                <td>
                    {{ expFeature.defaultSetting }}
                </td>
            </tr>
        </tbody>
    </table>
</section>
<section class="p-4">
    <h3>{{ 'FEATURE_TOGGLES.TITLE' | translate }}</h3>
    <p>{{ 'FEATURE_TOGGLES.DESCRIPTION' | translate }}</p>

    <table class="table table-dark table-hover">
        <thead>
            <tr>
                <th>{{ 'GENERAL.COLUMN.NAME' | translate }}</th>
                <th>{{ 'GENERAL.COLUMN.AVAILABLE' | translate }}</th>
                <th>{{ 'GENERAL.COLUMN.GROUP' | translate }}</th>
                <th>{{ 'GENERAL.COLUMN.DESCRIPTION' | translate }}</th>
                <th>{{ 'GENERAL.COLUMN.CREATION_DATE' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let featureToggle of allFeatureToggles">
                <td>{{ featureToggle.handle }}</td>
                <td>{{ availableForUser[featureToggle.handle] || false }}</td>
                <td>{{ featureToggle.group }}</td>
                <td>{{ featureToggle.description }}</td>
                <td>{{ featureToggle.createdAt | date: 'dd.MM.yyyy' }}</td>
            </tr>
        </tbody>
    </table>
</section>
